import { Config, Environment } from "./config";

export const local: Config = {
  environment: Environment.LOCAL,
  showEnvLabel: true,
  server: "http://localhost:8080",
};
